import RiskProfileModal from "./RiskProfileModal"
import PlaceProfileText from "./PlaceProfileText"

export default function PlaceSafetyProfile({ cardPlace }) {
    return (
        <>
            <RiskProfileModal />
            <PlaceProfileText cardPlace={cardPlace} />
        </>
    )
}
